count_one: <strong>1</strong> image
count_other: <strong>{{ count }}</strong> images

upload:
  title_one: Upload Image
  title_other: Upload Images
  fileReadFailed: "Failed to read file: {{ name }}"
  dropLabel_one: Drag & drop an image here
  dropLabel_other: Drag & drop images here
  invalidType: Image files only
  success: Image uploaded
edit:
  title: Edit Image
  zoomIn: Zoom In
  zoomOut: Zoom Out
picker:
  title: Image Picker
  accept_one: Choose Image
  accept_other: Choose Images
quality:
  _1080P: This photo is going to look great!
  _720P: This photo is good but it will pixelate on larger displays
  other: This image is too small or the wrong aspect ratio, please replace it
